/* eslint-disable @typescript-eslint/ban-ts-comment */
import clsx from 'clsx'
import React from 'react'
import { useStyle } from './Style'
import { LayoutProp } from './Type'

export const LayoutSeparator: React.FC<LayoutProp> = ({ className }): React.ReactElement => {
  const classes = useStyle()
  return <div className={clsx(classes.line, className)} data-testid="separatorLayout" />
}
